import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var PanelLargeIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props, {
    fill: "none"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M40.5 5C41.8807 5 43 6.11929 43 7.5V40.5C43 41.8807 41.8807 43 40.5 43H7.5C6.11929 43 5 41.8807 5 40.5V7.5C5 6.11929 6.11929 5 7.5 5H40.5ZM24 40.5V7.5L7.5 7.5L7.5 40.5H24Z"
  }));
});
PanelLargeIcon.displayName = 'PanelLargeIcon';
PanelLargeIcon.defaultProps = {
  'aria-label': 'Panel Large'
};
export default PanelLargeIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/PanelLargeIcon/index.js
// module id = 1907
// module chunks = 12